import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiBriefcase, FiMapPin, FiPhoneIncoming, FiPhoneOutgoing, FiPhoneCall,
  FiUserPlus, FiExternalLink, FiX, FiClock, FiUser,
} from 'react-icons/fi';
import { usePhoneCore, isInternalNumber } from '../../phone/PhoneContext';
import { formatClockDate, formatDuration, formatDmy } from '../../utils/formatters';
import DebtInfo from './DebtInfo';

// Mijoz kartasi. ATAYLAB o'zi ochilmaydi: operator jurnalda ismni bosganda
// ochiladi (`openCard`). Qo'ng'iroq kelganda ish maydoni tegilmaydi — kim
// qo'ng'iroq qilayotgani pastdagi telefon orolida ko'rinadi.
export default function PeerCard({ onSaveContact }) {
  const p = usePhoneCore();
  const card = p.card;
  if (!card || !card.number) return null;

  const number = card.number;
  const contact = card.contact;
  const history = card.calls || [];
  const name = contact?.name || '';
  const org = contact?.org_name || contact?.company || '';
  const branch = contact?.branch_name || '';
  const prior = history.filter((c) => c.status === 'answered');
  const lastNoted = history.find((c) => c.notes);
  const internal = isInternalNumber(number);
  const isPeer = p.peerNumber === number && (p.inCall || p.callState === 'incoming');

  return (
    <div className={`op2-peer g${isPeer ? ' live' : ''}`}>
      <div className="op2-peer-h">
        <div className="op2-av">{(name || number || '?').trim()[0].toUpperCase()}</div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="op2-peer-n">{name || (internal ? `Ichki raqam ${number}` : 'Nomsiz raqam')}</div>
          <div className="op2-peer-sub">
            <span className="op2-mono" style={{ fontSize: 13 }}>{number}</span>
            {org && <span><FiBriefcase size={11} style={{ verticalAlign: -1, marginRight: 4 }} />{org}</span>}
            {branch && <span><FiMapPin size={11} style={{ verticalAlign: -1, marginRight: 4 }} />{branch}</span>}
          </div>
          <div className="op2-peer-tags">
            {card.loading && <span className="op2-tag">yuklanmoqda…</span>}
            {!card.loading && !contact && !internal && <span className="op2-tag warn">Kontaktda yo'q</span>}
            {!card.loading && prior.length > 0 && (
              <span className="op2-tag ac">{prior.length} marta gaplashilgan</span>
            )}
            {!card.loading && contact && prior.length === 0 && (
              <span className="op2-tag">Birinchi suhbat</span>
            )}
            {history[0] && (
              <span className="op2-tag"><FiClock size={10} /> oxirgi {formatDmy(history[0].call_date)}</span>
            )}
            {isPeer && <span className="op2-tag ok">hozir shu raqam bilan aloqadasiz</span>}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, flexShrink: 0 }}>
          {!isPeer && (
            <button className="op2-btn go" onClick={() => p.dial(number, name)} title="Qo'ng'iroq qilish">
              <FiPhoneCall size={15} /> Qo'ng'iroq
            </button>
          )}
          {contact ? (
            <Link to={`contacts/${contact.id}`} className="op2-btn" style={{ textDecoration: 'none' }}>
              <FiExternalLink size={14} /> Kartasi
            </Link>
          ) : !internal ? (
            <button className="op2-btn ac" onClick={() => onSaveContact && onSaveContact(number)}>
              <FiUserPlus size={14} /> Kontaktga saqlash
            </button>
          ) : null}
          <button className="op2-iconbtn" onClick={p.closeCard} title="Kartani yopish">
            <FiX size={17} />
          </button>
        </div>
      </div>

      {/* Tashkilot qarzi (AuditApteka bazasidan) */}
      <DebtInfo debt={card.debt} />

      {/* Oldingi izoh — operator suhbatni nol nuqtadan boshlamaydi */}
      {lastNoted && (
        <div className="op2-quote">
          <div className="op2-quote-l">Oxirgi izoh · {formatClockDate(lastNoted.call_date)}</div>
          <div className="op2-quote-b">{lastNoted.notes}</div>
        </div>
      )}

      {/* Shu raqam bilan oxirgi qo'ng'iroqlar */}
      {history.length > 0 && (
        <div style={{ marginTop: 14, paddingTop: 13, borderTop: '1px solid var(--g-br-2)' }}>
          <div className="op2-quote-l" style={{ marginBottom: 8 }}>
            <FiUser size={11} style={{ verticalAlign: -1, marginRight: 5 }} />
            Shu raqam bilan oxirgi qo'ng'iroqlar
          </div>
          {history.slice(0, 5).map((c) => (
            <div
              key={c.id}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, fontSize: 13,
                color: 'var(--g-tx2)', padding: '4px 0', flexWrap: 'wrap',
              }}
            >
              {c.direction === 'inbound'
                ? <FiPhoneIncoming size={12} color="var(--g-ac)" />
                : <FiPhoneOutgoing size={12} color="var(--g-warn)" />}
              <span style={{ fontVariantNumeric: 'tabular-nums' }}>{formatClockDate(c.call_date)}</span>
              <span style={{ color: c.status === 'answered' ? 'var(--g-ok)' : 'var(--g-bad)', fontWeight: 700 }}>
                {c.status === 'answered' ? formatDuration(c.billable_sec || c.duration) : 'javobsiz'}
              </span>
              {c.operator_name && <span style={{ color: 'var(--g-tx3)' }}>· {c.operator_name}</span>}
              {c.notes && <span style={{ color: 'var(--g-tx3)' }}>· {c.notes}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
